class GameUI {
    dialogs: any;
    menu: any;
    chatBox: any;
    charStatus: any;
    character: any;
    inventory: any;
    questList: any;
    quickbar: any;
    buffBar: any;
    party: any;
    trade: any;
    vending: any;
    npcStore: any;
    skillList: any;
    options: any;
    knowledgeBase: any;
    map: any;
    minimap: any;
    gamemaster: any;

    constructor(character: any) {
        this.dialogs = [];
        this.menu = ui.menuDialog(character);
        this.chatBox = ui.chatBox();
        this.charStatus = ui.characterStatusDialog(character);
        this.character = ui.characterDialog(character);
        this.inventory = ui.inventoryDialog(character.inventory);
        this.questList = ui.questListDialog(character.quests);
        this.quickbar = ui.quickBarDialog(character.hotIcons);
        this.buffBar = ui.buffBarDialog(this.charStatus);
        this.party = ui.partyDialog(character.party);
        this.trade = ui.tradeDialog(character.trade);
        this.vending = ui.vendingDialog(character.vending);
        this.npcStore = ui.npcStoreDialog();
        this.skillList = ui.skillsDialog(character.skills);
        this.options = ui.optionsDialog(global.GAME_OPTIONS);
        this.knowledgeBase = ui.knowledgeBaseDialog();
        this.map = ui.mapDialog();
        this.minimap = ui.minimapDialog();
        this.gamemaster = character && character.isgm ? ui.gamemasterDialog() : null;

        this.character.hide();
        this.inventory.hide();
        this.vending.hide();
        this.npcStore.hide();
        this.questList.hide();
        this.skillList.hide();
        this.options.hide();
        this.knowledgeBase.hide();
        this.map.hide();
        if (this.gamemaster) {
            this.gamemaster.hide();
        }

        this.dialogs.push(this.menu);
        this.dialogs.push(this.chatBox);
        this.dialogs.push(this.charStatus);
        this.dialogs.push(this.character);
        this.dialogs.push(this.inventory);
        this.dialogs.push(this.questList);
        this.dialogs.push(this.quickbar);
        this.dialogs.push(this.buffBar);
        this.dialogs.push(this.party);
        this.dialogs.push(this.trade);
        this.dialogs.push(this.vending);
        this.dialogs.push(this.npcStore);
        this.dialogs.push(this.skillList);
        this.dialogs.push(this.options);
        this.dialogs.push(this.knowledgeBase);
        this.dialogs.push(this.map);
        this.dialogs.push(this.minimap);
        if (this.gamemaster) {
            this.dialogs.push(this.gamemaster);
        }

        this.menu.on(
            "toggle-character",
            this._toggleCharacterDialog.bind(this)
        );
        this.menu.on(
            "toggle-inventory",
            this._toggleInventoryDialog.bind(this)
        );
        this.menu.on(
            "toggle-quest-list",
            this._toggleQuestListDialog.bind(this)
        );
        this.menu.on(
            "toggle-skill-list",
            this._toggleSkillListDialog.bind(this)
        );
        this.menu.on("toggle-options", this._toggleOptionsDialog.bind(this));
        this.menu.on(
            "toggle-knowledge-base",
            this._toggleKnowledgeBaseDialog.bind(this)
        );
        this.menu.on("toggle-map", this._toggleMapDialog.bind(this));
        this.menu.on(
            "toggle-gamemaster",
            this._toggleGamemasterDialog.bind(this)
        );
    }

    _toggleCharacterDialog() {
        this.character.toggle();
    }

    _toggleInventoryDialog() {
        this.inventory.toggle();
    }

    _toggleQuestListDialog() {
        this.questList.toggle();
    }

    _toggleSkillListDialog() {
        this.skillList.toggle();
    }

    _toggleOptionsDialog() {
        this.options.toggle();
    }

    _toggleKnowledgeBaseDialog() {
        this.knowledgeBase.toggle();
    }

    _toggleMapDialog() {
        this.map.toggle();
    }

    _toggleGamemasterDialog() {
        if (this.gamemaster) {
            this.gamemaster.toggle();
        }
    }

    close() {
        for (let i = 0; i < this.dialogs.length; ++i) {
            this.dialogs[i].close();
        }

        this.dialogs = [];
    }
}

ui.GameUI = GameUI;
ui.gameUI = function (character: any) {
    return new ui.GameUI(character);
};
